import Entity from 'utilities/entity';

class Process extends Entity {
    
}

export default new Process();